/**
 * An account's medication preferences, set on Settings → Clinical → Medications. One rule, read
 * the same way by the add/edit dialog, the form filler, Add from preset and the preset editor.
 */

/** Whether staff must give a reason for taking medication. Off unless the account turned it on. */
export function requiresMedicationReason(account) {
    return account?.requireMedicationReason === true;
}

/** Whether a FHIR reasonCode holds a reason: text that isn't only spaces, or a coded reason. */
export function hasMedicationReason(reasonCode) {
    if (!Array.isArray(reasonCode)) return false;
    return reasonCode.some((reason) => (typeof reason?.text === 'string' && reason.text.trim() !== '') || (reason?.coding ?? []).some((coding) => !!coding?.code));
}
